import { initialize as initializeHTJ2K } from './decodeHTJ2K.js';
import { initialize as initializeJPEG2000 } from './decodeJPEG2000.js';
import { initialize as initializeJPEGLS } from './decodeJPEGLS.js';
import { initialize as initializeJPEGBaseline12Bit } from './decodeJPEGBaseline12Bit-js.js';
import { initialize as initializeJPEGLossless } from './decodeJPEGLossless.js';
import { initialize as initLibjpegTurbo } from './decodeJPEGBaseline8Bit.js';
import decodeHTJ2K from './decodeHTJ2K.js';
import decodeJPEG2000 from './decodeJPEG2000.js';
import decodeJPEGLS from './decodeJPEGLS.js';
import decodeJPEGBaseline12Bit from './decodeJPEGBaseline12Bit-js.js';
import decodeJPEGLossless from './decodeJPEGLossless.js';
import decodeJPEGBaseline8Bit from './decodeJPEGBaseline8Bit.js';
import decodeBigEndian from './decodeBigEndian.js';
import decodeLittleEndian from './decodeLittleEndian.js';
import decodeRLE from './decodeRLE.js';
const initializers = {
    HTJ2K: initializeHTJ2K,
    JPEG2000: initializeJPEG2000,
    JPEGLS: initializeJPEGLS,
    JPEGBaseline12Bit: initializeJPEGBaseline12Bit,
    JPEGLossless: initializeJPEGLossless,
    JPEGBaseline8Bit: initLibjpegTurbo,
};
const decoders = {
    HTJ2K: decodeHTJ2K,
    JPEG2000: decodeJPEG2000,
    JPEGLS: decodeJPEGLS,
    JPEGBaseline12Bit: decodeJPEGBaseline12Bit,
    JPEGLossless: decodeJPEGLossless,
    JPEGBaseline8Bit: decodeJPEGBaseline8Bit,
    BigEndian: decodeBigEndian,
    LittleEndian: decodeLittleEndian,
    RLE: decodeRLE,
};
export { initializers, decoders };
